import { addTranslations } from "@app/i18n";
import { useTranslation } from "react-i18next";

const RESOURCE_NAME = "supplier-questionnaire-header";

const keys = addTranslations(RESOURCE_NAME, {
    description_default: {
        en: "Fill the questionnaire and don't hesitate to contact us if you have any questions.",
        fr: "Remplissez le questionnaire et n'hésitez pas à nous contacter si vous avez des questions.",
    },
    stats_total: {
        en: "{{count}} questions",
        fr: "{{count}} questions",
    },
    stats_total_singular: {
        en: "1 question",
        fr: "1 question",
    },
    stats_answered: {
        en: "{{count}} in progress",
        fr: "{{count}} en cours",
    },
    stats_answered_singular: {
        en: "1 in progress",
        fr: "1 en cours",
    },
    stats_validated: {
        en: "{{count}} completed",
        fr: "{{count}} complétées",
    },
    stats_validated_other: {
        en: "{{count}} completed",
        fr: "{{count}} complétées",
    },
    stats_validated_one: {
        en: "1 completed",
        fr: "1 complétée",
    },
    stats_not_answered: {
        en: "{{count}} not answered",
        fr: "{{count}} non répondues",
    },
    stats_not_answered_singular: {
        en: "1 not answered",
        fr: "1 non répondu",
    },
    deadline_remaining_weeks: {
        en: "1 week remaining",
        fr: "1 semaine restante",
    },
    deadline_remaining_weeks_zero: {
        en: "0 weeks remaining",
        fr: "0 semaine restante",
    },
    deadline_remaining_weeks_other: {
        en: "{{count}} weeks remaining",
        fr: "{{count}} semaines restantes",
    },
    deadline_overdue: {
        en: "Overdue",
        fr: "En retard",
    },
});

export function useSupplierQuestionnaireHeaderTranslations() {
    const { t } = useTranslation(RESOURCE_NAME);
    return { t, keys };
}
